import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DfQuillEditorModule, DfSharedButtonModule, LevelSliderMaterialModule, PipesModule } from '@platri/dfx-angular-core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { CourseRulesFormComponent } from './course-rules-form.component';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {TranslocoDirective} from "@jsverse/transloco";

@NgModule({
  declarations: [CourseRulesFormComponent],
  exports: [CourseRulesFormComponent],
    imports: [
        CommonModule,
        FormsModule,
        PipesModule,
        MatIconModule,
        MatButtonModule,
        RouterModule,
        MatCardModule,
        MatDividerModule,
        DfSharedButtonModule,
        MatFormFieldModule,
        MatInputModule,
        DfQuillEditorModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        LevelSliderMaterialModule,
        TranslocoDirective
    ]
})
export class CourseRulesFormModule {}
